import { EChatActionTypes } from '@r1-frontend/entities/Chat/store/constants/actions';

const open = (): { type: EChatActionTypes.OPEN_CHAT } => ({
    type: EChatActionTypes.OPEN_CHAT,
});

export default open;
